import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Box, IconButton } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { ArrowLeftIcon, MutualLogoWhite } from '~/assets/icons'
import { transparentize } from 'polished'

const useStyles = makeStyles({
  logoContainer: {
    height: mutualTheme.topbar.height,
    marginLeft: mutualTheme.spacing(4),
    marginRight: mutualTheme.spacing(2),
    color: transparentize(0.65, mutualTheme.palette.common.white)
  }
})

export type SidebarExpandedHeaderProps = {
  onClose: () => void
}

export const SidebarExpandedHeader: React.FC<SidebarExpandedHeaderProps> = (props) => {
  const { onClose } = props
  const classes = useStyles()

  return (
    <Box style={{ display: 'inline-flex', justifyContent: 'space-between', alignItems: 'center' }} className={classes.logoContainer}>
      <MutualLogoWhite />
      <IconButton color='inherit' onClick={onClose}>
        <ArrowLeftIcon />
      </IconButton>
    </Box>
  )
}
